import { type DependencyList, useMemo } from "react";
import { useServices } from "appServices";
import type { BasketFormValues } from "helpers/forms/baseTypes";
import { isGbPricingPlan } from "helpers/pricingPlan";
import type { CompanyData } from "services/company/companyTypes";
import { PricingPlan, type PricingPlanGb } from "services/pricingPlan/pricingPlanTypes";
import type { ServicesGb } from "servicesGb";

export enum BasketQuestion {
  Pricing = "PRICING",
  VirtualOfficeSelection = "VIRTUAL_OFFICE_SELECTION",
  Checkout = "BASKET_CHECKOUT",
}

export const BASKET_FIELD_TO_PATH: Record<BasketQuestion, string> = {
  [BasketQuestion.Pricing]: "pricing",
  [BasketQuestion.VirtualOfficeSelection]: "virtual-office",
  [BasketQuestion.Checkout]: "checkout",
};

const getPricingPlanFormValue = (company?: CompanyData): PricingPlanGb | undefined => {
  if (!company?.pricingPlan || company.pricingPlan === PricingPlan.Unknown) {
    return;
  }

  if (!isGbPricingPlan(company.pricingPlan)) {
    return;
  }

  return company.pricingPlan;
};

const basketDataToBasketForm = (company?: CompanyData): BasketFormValues => {
  return {
    pricingPlan: getPricingPlanFormValue(company),
  };
};

export const useBasketFormInitialValues = (deps: DependencyList = []): BasketFormValues | undefined => {
  const { companyStore } = useServices<ServicesGb>();

  return useMemo(() => basketDataToBasketForm(companyStore.company), deps);
};
